import { render, staticRenderFns } from "./categorySheType.vue?vue&type=template&id=f6de96b4&scoped=true&"
import script from "./categorySheType.vue?vue&type=script&lang=js&"
export * from "./categorySheType.vue?vue&type=script&lang=js&"
import style0 from "./categorySheType.vue?vue&type=style&index=0&id=f6de96b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6de96b4",
  null
  
)

export default component.exports